import { JSX, useCallback } from "react";

import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import TableRow from "@mui/material/TableRow";

import ManagedTextField from "utils/edit/ManagedTextField";
import ColourPicker from "utils/elements/ColourPicker";

import { RatingInfo } from "core/field/FieldService";

export type RatingSettingsRowProps = {
	index: number;
	value: RatingInfo;
	disabled?: boolean;

	onChangeName: (index: number, name: string) => void;
	onChangeDescription: (index: number, description: string) => void;
	onChangeColour: (index: number, colour: string) => void;
};

function RatingSettingsRow(props: RatingSettingsRowProps): JSX.Element {
	const onChangeName = useCallback(
		(value: string): void => {
			props.onChangeName(props.index, value);
		},
		[props.onChangeName, props.value]
	);

	const onChangeDescription = useCallback(
		(value: string): void => {
			props.onChangeDescription(props.index, value);
		},
		[props.onChangeName, props.value]
	);

	const onChangeColour = useCallback(
		(value: string): void => {
			props.onChangeColour(props.index, value);
		},
		[props.onChangeName, props.value]
	);

	return (
		<TableRow>
			<TableCell style={{ width: 40 }} component="th" scope="row">
				<Typography style={{ marginTop: 4 }}>
					{props.index + 1}
				</Typography>
			</TableCell>
			<TableCell style={{ width: 180 }}>
				<ManagedTextField
					variant="standard"
					fullWidth
					value={props.value.name}
					disabled={props.disabled}
					onUpdate={onChangeName}
				/>
			</TableCell>
			<TableCell style={{ width: 40 }}>
				<ColourPicker
					value={props.value.colour}
					disabled={props.disabled}
					onChange={onChangeColour}
				/>
			</TableCell>
			<TableCell>
				<ManagedTextField
					variant="standard"
					fullWidth
					multiline
					value={props.value.description}
					disabled={props.disabled}
					onUpdate={onChangeDescription}
				/>
			</TableCell>
		</TableRow>
	);
}

export default RatingSettingsRow;
